export function exportAsFile(
  contents: string,
  desiredFilename: string,
  options?: BlobPropertyBag,
) {
  const objectURL = URL.createObjectURL(new Blob([contents], options))
  const hiddenElement = document.createElement('a')
  try {

    hiddenElement.setAttribute('style', 'display: none;')
    hiddenElement.download = desiredFilename
    hiddenElement.href = objectURL

    document.body.appendChild(hiddenElement) // required for firefox
    hiddenElement.click()

  } finally {
    hiddenElement.remove()
    URL.revokeObjectURL(objectURL)
  }
}
